import {
  Button,
  FormControl,
  FormHelperText,
  makeStyles,
  TextField
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import MessagePanel from "../../components/messagePanel";
import { validatePassword } from "../../helpers/validate.helper";
import { authActions } from "../../store/actions/auth.actions";
import { IDRaksStore } from "../../store/store";
import { ZmianaHaslaPageStyle } from "../../styles/ZmianaHaslaPageStyle";

interface ZmianaHaslaPageProps {
  error: string;
  email: string;
  onClearError: Function;
  onSave: Function;
  onGetSession: Function;
}

export const ZmianaHaslaPage = (props: ZmianaHaslaPageProps) => {
  const { error, onClearError, onSave, onGetSession } = props;

  useEffect(() => {
    onGetSession();
    return () => {
      onClearError();
    };
    // eslint-disable-next-line
  }, []);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");

  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [repeatedPasswordError, setRepeatedPasswordError] = useState("");

  function save() {
    const oldPswdError = !oldPassword ? "Pole wymagane" : "";
    setOldPasswordError(oldPswdError);
    const newPswdError = validatePassword(newPassword);
    setNewPasswordError(newPswdError);

    let repeatedPswdError = !repeatedPassword ? "Pole wymagane" : "";
    if (newPassword && repeatedPassword && newPassword !== repeatedPassword)
      repeatedPswdError = "Hasło i powtórzone hasło nie są identyczne.";
    setRepeatedPasswordError(repeatedPswdError);

    if (!oldPswdError && !newPswdError && !repeatedPswdError) {
      onSave(oldPassword, newPassword);
    }
  }

  const useStyles = makeStyles({
    input: {
      fontFamily: "text-security-disc"
    }
  });

  const classes = useStyles();

  return (
    <ZmianaHaslaPageStyle>
      <header>
        <h5>Hasło</h5>
        <Button
          name="btnZapisz"
          color="secondary"
          variant="contained"
          onClick={save}
        >
          ZAPISZ
        </Button>
      </header>
      <>
        {error && <MessagePanel title="Błąd!" mode="error" message={error} />}
        <div className="panel">
          <h6 className="high">Utwórz nowe hasło dla swojego konta</h6>
          <div className="panel__dane">
            <FormControl error={oldPasswordError !== ""} className="password">
              <TextField
                value={oldPassword || ""}
                onChange={(e) => setOldPassword(e.target.value)}
                label="Stare hasło"
                InputProps={{ classes: { input: classes.input } }}
              />
              {oldPasswordError && (
                <FormHelperText id="oldpassword-error-text">
                  {oldPasswordError}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl error={newPasswordError !== ""} className="password">
              <TextField
                value={newPassword || ""}
                onChange={(e) => setNewPassword(e.target.value)}
                label="Nowe hasło"
                InputProps={{ classes: { input: classes.input } }}
                helperText={
                  "Użyj co najmniej 8 znaków, zastosuj małe i duże litery oraz cyfry."
                }
              />
              {newPasswordError && (
                <FormHelperText id="newpassword-error-text">
                  {newPasswordError}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl error={repeatedPasswordError !== ""}>
              <TextField
                value={repeatedPassword || ""}
                onChange={(e) => setRepeatedPassword(e.target.value)}
                label="Powtórz nowe hasło"
                InputProps={{ classes: { input: classes.input } }}
              />
              {repeatedPasswordError && (
                <FormHelperText id="repeatedpassword-error-text">
                  {repeatedPasswordError}
                </FormHelperText>
              )}
            </FormControl>
          </div>
        </div>
      </>
    </ZmianaHaslaPageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    error: store.auth.error
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onSave: (haslo: string, noweHaslo: string) =>
      dispatch(authActions.changePassword(haslo, noweHaslo)),
    onClearError: () => dispatch(authActions.clearError()),
    onGetSession: () => dispatch(authActions.getSessionData())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZmianaHaslaPage);
